export default {
      id: "plus-circle-usage",
      viewBox: "0 0 16 16",
      url: "/" + "img/marilyn-ui.svg#plus-circle",
      toString: function () {
        return this.url;
      }
    }